<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="70%"
      :scrollable="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon name="search" v-bind="attrs"
          v-on="on">
            <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>
      <v-card class="px-2 pt-2">
          <v-container>
              <p class="text-h6 mb-5 grey lighten-3 pl-1 rounded">
              Search for Projects, Teams and Participants
              </p>
          <v-row>
              <v-col cols="4">
                <v-text-field
                    outlined
                    :label="searchFor ? `${searchFor.toUpperCase().slice(0, -1)}` : 'SEARCH'"
                />
              </v-col>
              <v-col cols="2">
                <v-select
                    :items="searchForItems"
                    item-text="name"
                    item-value="value"
                    v-model="searchFor"
                    label="Search for"
                />
              </v-col>
          </v-row>
          </v-container>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="deep-purple"
                text
                @click="dialog = false"
            >
                Done
            </v-btn>
            </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
    data() {
        return {
            dialog: false,
            searchFor: 'projects',
            searchForItems: [
                {name: 'Projects', value: 'projects'},
                {name: 'Teams', value: 'teams'},
                {name: 'Participants', value: 'participants'},
            ]
        }
    }
}
</script>
<style scoped>
* >>> .my-custom-dialog {
  align-self: flex-start;
  overflow-x: hidden;
}
</style>